import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';
import Emitter from './Emitter';

export default class PopBubble extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, number)
    {
        super(scene);

        this.letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q",
            "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

        this.enabled = true;
        this.number = number;
        this.letter = this.letters[number];

        this.backgroundImage = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._bubble, this).setOrigin(0);

        this.textLabel1 = ABCyaPhaser.Text.addText(0, 0, 44, 0xffffff, FontKeys._odin_roundedregular, this.letter, this).setOrigin(0.5);
        this.textLabel1.x = this.backgroundImage.width / 2;
        this.textLabel1.y = this.backgroundImage.height / 2 ;

        this.createBodyDef();

        ABCyaPhaser.Container.setContainerInteractive(this, false);
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);
    }

    createBodyDef()
    {
        let fixture = new Box2D.Dynamics.b2FixtureDef;
        fixture.density = 1;
        fixture.restitution = 0.6;
        fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(50 / SCALE);

        this.fixture = fixture;

        let bodyDef = new Box2D.Dynamics.b2BodyDef;
        bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;

        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this);
        bodyDef.position.x = globalPt.x / SCALE;
        bodyDef.position.y = globalPt.y / SCALE;

        this.bodyDef = bodyDef;
    }

    doClick()
    {
        //drop number
        //we'll generate our body from the caller (GameScreen)
        //if its over the incorrect letter box that is full we initiate physics
        // else we animate a drop to the empty letter box
        this.clickAction(this);
    }

    pop(num)
    {
        if (!this.enabled) { return; }

        ABCyaPhaser.Audio.playOneShot("pop"+num, this.scene);

        //explode and drop only once!
        this.enabled = false;

        this.backgroundImage.alpha = 0;
        this.textLabel1.alpha = 0;

        let emitter = new Emitter(this.scene, 5);
        emitter.x = -20;
        emitter.y = 20;

        this.add(emitter);
        emitter.emitParticles("bubble", 10);
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;